var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBankTransfer = function SvgBankTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.08 19.1a5.7 5.7 0 0 0 .685 1.9H2.5v-1.9zM19.6 12.775A5.7 5.7 0 0 0 12 18.15H4.4V11.5h15.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.5 6.75v3.8h-19v-3.8L12 2zM12 5.8a.95.95 0 1 0 0 1.9.95.95 0 0 0 0-1.9",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.512 19.355h3.641c.183 0 .331-.16.331-.357 0-.198-.148-.358-.33-.358h-2.65c-.913 0-1.654-.8-1.654-1.787 0-.988.74-1.788 1.655-1.788h.662v-.715h1.324v.715h1.656v1.43h-3.642c-.183 0-.331.16-.331.358s.148.357.33.357h2.65c.913 0 1.655.8 1.655 1.788 0 .987-.742 1.788-1.656 1.788h-.662v.715h-1.324v-.715h-1.655z"
  })));
};
export default SvgBankTransfer;